module.exports = __webpack_public_path__ + "assets/img/Australian-Seniors-Content-Marketing-w540.7f03033b.webp";